import { InvoiceState } from 'modules/entities/modules/documents-invoices/types';
import { ContractState } from 'modules/entities/modules/documents-contracts/types';
import { OtherDocumentState } from 'modules/entities/modules/other-documents';
import { WorkOrderState } from 'modules/entities/modules/workorders';
import { TRuleWithTheme } from 'styles/theme';
import { Tables } from '../../types';
import { StatusIconSize } from './types';

const colorMap = theme => ({
    [Tables.INVOICES]: {
        [InvoiceState.NEW]: theme.colors.statusNew,
        [InvoiceState.CORRECT]: theme.colors.statusSuccess,
        [InvoiceState.IN_CLARIFICATION]: theme.colors.statusInClarification,
        [InvoiceState.WRONG]: theme.colors.statusHighAlert,
        [InvoiceState.ONGOING]: theme.colors.statusOngoing,
        [InvoiceState.NOT_CHECKED]: theme.colors.statusNotChecked,
        [InvoiceState.SHOW_ALL]: theme.colors.statusInfo,
    },
    [Tables.CONTRACTS]: {
        [ContractState.CANCELATION_5_MONTHS]: theme.colors.statusOngoing,
        [ContractState.CANCELED]: theme.colors.statusNew,
        [ContractState.ACTIVE]: theme.colors.statusSuccess,
        [ContractState.INACTIVE]: theme.colors.statusInactive,
    },
    [Tables.OTHER_DOCUMENTS]: {
        [OtherDocumentState.ONGOING]: theme.colors.statusOngoing,
        [OtherDocumentState.NEW]: theme.colors.statusNew,
        [OtherDocumentState.DONE]: theme.colors.statusSuccess,
    },
    [Tables.WORKORDERS]: {
        [WorkOrderState.NEW]: theme.colors.statusInfo,
        [WorkOrderState.IN_CLARIFICATION]: theme.colors.statusWarning,
        [WorkOrderState.NOT_RELEVANT]: theme.colors.statusInactive,
        [WorkOrderState.RUNNING]: theme.colors.statusSuccess,
        [WorkOrderState.WAITING_FOR_ASSISTANT]: theme.colors.borderPrimaryHover,
        [WorkOrderState.WAITING_FOR_TECHNICIAN]: theme.colors.pinkColor,
        [WorkOrderState.TECHNICIAN_REVIEW_REQUIRED]: theme.colors.lightBlue,
        [WorkOrderState.FINISHED]: theme.colors.outlineStatusSuccess,
        [WorkOrderState.REJECTED]: theme.colors.statusHighAlert,
        [WorkOrderState.TECHNICAL_Q_CHECK_DONE]: theme.colors.info,
        [WorkOrderState.IN_REVIEW]: theme.colors.statusWarning,
        [WorkOrderState.FULFILLED]: theme.colors.simplifa2,
        [WorkOrderState.FUTILE_TRAVEL]: theme.colors.darkGreen,
        [WorkOrderState.UNKNOWN]: theme.colors.statusInfo,
        [WorkOrderState.SHOW_ALL]: theme.colors.statusInfo,
    },
});

export const icon: TRuleWithTheme<{
    state?: InvoiceState | ContractState | OtherDocumentState | WorkOrderState;
    table: Tables;
    size: StatusIconSize;
}> = ({ theme, table, state, size }) => ({
    color: colorMap(theme)[table][state] ?? theme.colors.icon,
    extend: {
        condition: size === StatusIconSize.SMALL,
        style: {
            marginRight: '.5rem',
            fontSize: '1rem',
            '& svg': {
                height: '.875rem',
                width: '.875rem',
            },
        },
    },
});
